import { createApp } from 'vue'
import DownloadOverview from './downloadOverview.vue'


document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('download-overview')
       if (!el) return


    // SearchHistoryService.create();
    createApp(DownloadOverview, { })
        .mount(el)
})
